import { useTypedSelector } from "store"
import styled from "styled-components"

export const getColorImages = (state) => {
  const selectedColorCode = state?.color?.selectedColorCode
  const colors = state?.color?.colors

  return colors.reduce((a, b) => {
    if (a.length !== 0) return a

    if (b?.details?.code === selectedColorCode) {
      return b
    }

    return a
  }, [])
}

export const retrieveImages = (state) => {
  const selectedColorImages = getColorImages(state)

  const outsideImages = selectedColorImages?.details?.outsideImages

  const selectedUpholsteryCode = state?.upholstery?.selectedUpholsteryCode

  const selectedUpholsteryImages = state?.upholstery?.upholsteries.reduce(
    (a, b) => {
      if (a.length !== 0) return a

      if (b?.details?.code === selectedUpholsteryCode) {
        return b
      }

      return a
    },
    []
  )

  const insideImages = selectedUpholsteryImages?.details?.insideImages

  if (!insideImages || !outsideImages) return []

  return [...outsideImages, ...insideImages]
}

const StyledImageContainer = styled.div``

const StyledImg = styled.img<{ $small: boolean }>`
  width: ${(p) => (p.$small ? "calc(50% - 5px)" : "100%")};
  /* height: ${(p) => (p.$small ? "320px" : "400px")}; */
  aspect-ratio: ${(p) => (p.$small ? "380/320" : "770/400")};
  object-fit: cover;
  border-radius: 2px;
  margin-bottom: 3px;

  :nth-child(3n - 1) {
    margin-left: 10px;
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    height: ${(p) => (p.$small ? "130px" : "200px")};
  }
`

type SummaryGalleryProps = {
  className?: string
}

const SummaryGallery = ({ className }: SummaryGalleryProps) => {
  const state = useTypedSelector((state) => state)
  const images = retrieveImages(state)

  let index = 0

  const checkIfSmall = (i) => {
    if (i === 0) {
      return false
    }

    if (index === 2) {
      index = 0
      return false
    }

    index++
    return true
  }

  return (
    <StyledImageContainer className={className}>
      {images.map((image, i) => (
        <StyledImg
          $small={checkIfSmall(i)}
          src={image?.imageUrl}
          alt={image?.alt}
          key={i + image?.imageUrl}
        />
      ))}
    </StyledImageContainer>
  )
}

export default SummaryGallery
